var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Music-Note-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Music Note 1 Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.83 3.21c-1 -0.64 -1.45 -1.3 -1.45 -2a1.25 1.25 0 0 0 -2.5 0v14.5a0.25 0.25 0 0 1 -0.25 0.25H9.38a4 4 0 0 0 0 8 4.11 4.11 0 0 0 4 -4V5.73a0.23 0.23 0 0 1 0.14 -0.22 0.23 0.23 0 0 1 0.26 0c3.42 2.47 2.43 5 1.3 8 -0.39 1 -0.07 1.65 0.6 1.91s1.33 0 1.73 -1c1.16 -3.02 2.9 -7.55 -2.58 -11.21Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusic);
export default ForwardRef;